module.exports = __webpack_public_path__ + "static/media/ruby.30c2c9b6.png";